import * as d3 from "d3";
import "./css/style.less";
import cfg from "./config.json";
import ecoles from "./data/ecoles.json";
import ehdaa from "./data/ehdaa.json";
import { map } from "./components/map.js";
import { list } from "./components/list.js";
import { comparator } from "./components/comparator.js";

// new EventSource("/esbuild").addEventListener("change", () => { location.reload(); });

ecoles.forEach(d => {
  d._id = +d._id;
  d.étudiants = +d.étudiants;
  d.cote_2023 = d.cote_2023 != "nd" ? +d.cote_2023 : d.cote_2023;
  d.cote_2024 = d.cote_2024 != "nd" ? +d.cote_2024 : d.cote_2024;
  d.rang = d.rang != "nd" ? +d.rang : d.rang;
});
// console.table(ecoles.map(d => {
  // return [d._id, d.étudiants, d.cote_2023, d.cote_2024, d.rang];
  // return [d.school_name_1, d.nom_court, d.nom_offcl];
// }));

var data = {
  config: cfg,
  prev_ecoles: Array.from(ecoles).sort((a,b) => d3.ascending(a.nom_court, b.nom_court)).sort((a,b) => d3.descending(a.cote_2024, b.cote_2024)),
  ecoles: Array.from(ecoles).sort((a,b) => d3.ascending(a.school_name_1, b.school_name_1)).sort((a,b) => d3.descending(a.cote_2024, b.cote_2024)),
  ehdaa: ehdaa
};

function init() {
  const sel = d3.select("#viz");
  sel.select("#map-container").call(map, data);
  sel.select("#list").call(list, data);
  sel.select("#comparator").call(comparator, data);

  let lexique = d3.select('.lexique');
  let collapsed = lexique.selectAll(".collapsed").each(function(d, i) {
    d3.select(this).select(".collapse-trigger").on("click", () => {
      d3.select(this).classed("collapsed", ! d3.select(this).classed("collapsed"))
    })
  });

  let comparateurTrigger = document.querySelector('#triggerComparateur');
  let comparateurBtnTrigger = document.querySelector('#triggerBoutonComparateur');
  let comparateurBtn = document.querySelector('#boutonComparateur');
  let comparateur = document.querySelector('#comparateur');

  var elementInView = (el, dividend = 1) => {
    var elementTop = el.getBoundingClientRect().top;
    return (
        elementTop <=
        (window.innerHeight || document.documentElement.clientHeight) / dividend
    );
  };

  var handleScrollAnimation = () => {
    if(elementInView(comparateurTrigger,1)){
      comparateur.classList.remove("minified");
      comparateurBtn.classList.add("visible");
    } else {
      comparateur.classList.add("minified");
      comparateurBtn.classList.remove("visible");
    }
    if(elementInView(comparateurBtnTrigger,1)){
      comparateurBtn.classList.add("minified");
    } else {
      comparateurBtn.classList.remove("minified");
    }
  }

  window.addEventListener("scroll", () => {
    handleScrollAnimation();
  });

  window.addEventListener("load", () => {
    handleScrollAnimation();
  });



  document.querySelector('#scrollToMap').addEventListener("click",(e)=>{
    e.preventDefault();
    const mapContainer = document.querySelector("#carte");
    mapContainer.scrollIntoView({ behavior: "smooth",  inline: "nearest" });
  })
  document.querySelector('#scrollToList').addEventListener("click",(e)=>{
    e.preventDefault();
    const listContainer = document.querySelector("#list");
    listContainer.scrollIntoView({ behavior: "smooth",  inline: "nearest" });
  })
}

init();

